export default function IQButton(){
    return(
        <button onClick = { () => alert("Interview Questions!") }
            style = { { width : "32px", height : "32px", borderRadius : "100%", background : "white", border : "2px solid var(--black16)", color : "var(--black56)" } }>
            IQ
        </button>
    )
}